<template>
  <b-modal
    id="modal-manage-html"
    scrollable
    no-close-on-esc
    no-close-on-backdrop
    @show="modalShow"
    @hidden="modalHidden"
  >
    <template #modal-header>
      <div
        class="d-inline-flex justify-content-between align-items-center w-100"
      >
        <div class="d-flex align-items-center">
          <TitleModal
            :label="$t('engine.manageHtml.lblTitle', languageEngine)"
          />
        </div>
        <div class="d-flex align-items-center">
          <div
            @click="closeModal()"
            type="button"
            aria-label="Close"
            id="close-modal-manage-html"
            class="ml-10 icon-close-modal fs-24"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>
    <template>
      <b-overlay variant="white" :opacity="0.8" :show="loading">
        <p class="fs-db-20 mb-0">
          {{ $t("engine.manageHtml.lblPlaceHolder", languageEngine) }}
        </p>
        <div class="mt-4" :class="isError ? 'errors' : ''">
          <b-form-textarea
            class="form-control"
            v-model="html"
            :show="!loading"
            @keydown="isError = false"
          ></b-form-textarea>
          <div class="mt-4">
            <span v-if="isError" class="fs-sa-12 text-danger">{{
              $t("engine.manageHtml.lblError", languageEngine)
            }}</span>
          </div>
        </div>
      </b-overlay>
    </template>
    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click="save($event)">
        <i class="far fa-check"></i>
        {{ $t("engine.common.btnSave", languageEngine) }}
      </b-button>
      <b-button variant="default" @click="closeModal()">
        <i class="far fa-times"></i>
        {{ $t("engine.common.btnCancel", languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

export default {
  components: {
    TitleModal,
  },
  data() {
    return {
      loading: true,
      html: "",
      onSave: () => {},
      isError: false,
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      modal: "design/modal",
      modalPayload: "design/modalPayload",
      components: "design/metadata/components",
      modals: "design/modals/modals",
      modalActive: "design/modals/modalActive",
    }),
  },
  methods: {
    modalShow() {
      if (this.modal) {
        this.html = this.modalPayload.html;
        this.onSave = this.modalPayload.onSave;
      } else {
        this.html = this.modals[this.modalActive].payload.html;
      }
      this.loading = false;
    },
    modalHidden() {
      this.html = "";
      this.loading = true;
      (this.isError = false), this.closeModal();
    },
    save() {
      let html = this.html;  
      if (html == "" || html.trim().length == 0) {
        this.isError = true;
      } else {
        // remove special charactor
        html = html.replace(/[”″]/g, '"');
       
         // remove tag and inside
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const tagsToRemove = ['head',  'script', 'style'];

        tagsToRemove.forEach(tagName => {
          const elements = doc.querySelectorAll(tagName);
          elements.forEach(element => {
            element.parentNode.removeChild(element);
          });
        });
        
        html = doc.body.innerHTML;

        // remove only word
        const wordToRemove = ['<!DOCTYPE html>', '<html>', '</html>', '<body>', '</body>'];
        wordToRemove.forEach(word => {
          html = html.replace(new RegExp(word, 'gi'), '');
        });

        html = html.trim();
        
        if (this.modal) {
          this.onSave(html);
        } else {
          this.$store.dispatch(
            "designIframe/modals/callback",
            {
              key: "modal-manage-html",
              clear: false,
              func: "onSave",
              data: {
                html: html,
              },
            },
            { root: true }
          );
        }
        this.closeModal();
      }
    },
    closeModal() {
      this.$bvModal.hide("modal-manage-html");
      this.$store.dispatch("design/setModal", { name: "" });
      this.$store.dispatch("designIframe/modals/setModal", {
        modal_id: "",
        id: "",
        payload: {},
        callback: {},
      });
    },
  },
  watch: {
    modal: {
      handler() {
        if (this.modal == "modal-manage-html") {
          this.$bvModal.show("modal-manage-html");
        }
      },
    },
    modalActive: {
      handler() {
        if (this.modalActive == "modal-manage-html") {
          this.$bvModal.show("modal-manage-html");
        }
      },
    },
  },
};
</script>

<style lang="scss">
#modal-manage-html {
  textarea {
    width: 100%;
    height: auto;
    min-height: 180px;
    max-height: 70vh;
  }
}
</style>
